(function () {
    
    async function loadProductDocument(path) {
        console.log('descargaDocumento ruta:',path);

        const fetchOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                'path':path,
                'shop':Shopify.shop,
                'customerId':__st.cid,
            })
        };

        await fetch('/apps/upango_royalbio/product-documents/', fetchOptions).then(response => {
            if (response.ok) {
                return response.blob();
            } else {
                //TODO: Mostar error
                throw new Error(`Error en la respuesta: ${response.status} - ${response.statusText}`);
            }
        })
        .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        })
        .catch(error => {
            const divDocuments = document.querySelector('.product-documents');
            showErrorMessages(divDocuments,[productDocumentsErrorMessages.product_document_download_error]);
            console.error('Error al obtener la ficha tecnica:', error);
        });
    }

    function showRequestProductDocumentForm(documentPath) {
        console.log("showRequestProductDocumentForm");
        // Añadimos el documento solicitado a la información que llegará por mail
        var formBody = document.getElementById("upng-product-document-form-body");
        var formBodyValue = formBody.value;
        formBody.value = formBodyValue + " Documento solicitado: "+documentPath;
        //Mostramos el formulario
        document.getElementById('ProductDocumentModalForm').show();
    }

    const buttons = document.querySelectorAll(".button-product-document");
    buttons.forEach(function(button) {
        button.addEventListener("click",async function(event) {
            const documentPath = this.dataset.path;
            if(__st.cid!=null && __st.cid!=""){
                showLoading(button,true);
                await loadProductDocument(documentPath);
                showLoading(button,false);
            } else {
                showRequestProductDocumentForm(documentPath);
            }
        });
    });

})();